// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skills section */
.skills {
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 5rem;
  color: white;
  margin: 3rem 0;
  text-align: center;
  margin-top: 5%;
  letter-spacing: 0.3rem;
}

.skill-cards {
  background-color: gray;
  padding: 1.2rem 1rem 1rem 1rem;
  margin: 1.2rem;
  width: 10rem;
  border-radius: 8px;
  color: #ffffff;
}

.skill-icon {
  color: white;
  font-size: 8rem;
}

.skill-holder {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  justify-content: space-evenly;
  align-items: center;
  margin: 2em 0;
}

.skill {
  font-size: 1.5em;
  font-weight: bolder;
  text-align: center;
  text-shadow: 2px 3px 4px #000000;
  text-transform: uppercase;
}

.skill-cards:hover {
  box-shadow: 0px 2px 10px #000000;
}

@media (max-width: 500px) {
  .title {
    font-size: 4rem;
    margin: 3rem 0;
    text-align: center;
    margin-top: 8%;
    letter-spacing: 0.3rem;
  }

  .skill-cards {
    background-color: gray;
    padding: 1.2rem 1rem 1rem 1rem;
    margin: 0.2rem;
    width: 7em;
    border-radius: 8px;
    color: #ffffff;
  }

  .skill-icon {
    color: white;
    font-size: 40px;
  }

  .skill-holder {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-evenly;
    align-items: center;
    margin: 4em 0;
  }

  .skill {
    padding: 0;
    font-size: 0rem;
  }
}

/* End Skills section */
`, "",{"version":3,"sources":["webpack://./src/components/Skills.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,uBAAuB","sourcesContent":["/* Skills section */\n.skills {\n  height: 50vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.title {\n  font-size: 5rem;\n  color: white;\n  margin: 3rem 0;\n  text-align: center;\n  margin-top: 5%;\n  letter-spacing: 0.3rem;\n}\n\n.skill-cards {\n  background-color: gray;\n  padding: 1.2rem 1rem 1rem 1rem;\n  margin: 1.2rem;\n  width: 10rem;\n  border-radius: 8px;\n  color: #ffffff;\n}\n\n.skill-icon {\n  color: white;\n  font-size: 8rem;\n}\n\n.skill-holder {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  list-style: none;\n  justify-content: space-evenly;\n  align-items: center;\n  margin: 2em 0;\n}\n\n.skill {\n  font-size: 1.5em;\n  font-weight: bolder;\n  text-align: center;\n  text-shadow: 2px 3px 4px #000000;\n  text-transform: uppercase;\n}\n\n.skill-cards:hover {\n  box-shadow: 0px 2px 10px #000000;\n}\n\n@media (max-width: 500px) {\n  .title {\n    font-size: 4rem;\n    margin: 3rem 0;\n    text-align: center;\n    margin-top: 8%;\n    letter-spacing: 0.3rem;\n  }\n\n  .skill-cards {\n    background-color: gray;\n    padding: 1.2rem 1rem 1rem 1rem;\n    margin: 0.2rem;\n    width: 7em;\n    border-radius: 8px;\n    color: #ffffff;\n  }\n\n  .skill-icon {\n    color: white;\n    font-size: 40px;\n  }\n\n  .skill-holder {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    list-style: none;\n    justify-content: space-evenly;\n    align-items: center;\n    margin: 4em 0;\n  }\n\n  .skill {\n    padding: 0;\n    font-size: 0rem;\n  }\n}\n\n/* End Skills section */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
